import {
  GSForm,
  GSSidePanelPage,
  useFormDataValidation,
} from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

//import scss
import "./package-access-form.scss";

import {
  useNotificationAction,
  useNotificationBanner,
  useNotifications,
} from "../../../../hooks/notificationHooks";
import { getAccessListForm } from "../../../../forms/AccessListForm";
import { useDispatch, useSelector } from "react-redux";
import {
  getTournamentAccessCode,
  selectAccessListCredentials,
  selectPublicTournament,
  setAccessListCredentials,
} from "../../../../reducers/tournamentSlice";
import {
  clearNotifications,
} from "../../../../reducers/registrationOrderSlice";

import { FULFILLED } from "../../../../app/api";
import { applyAccessCodes } from "../../../../reducers/registrationOrderSlice";
import { useGolfstatusNavigate } from "../../../../hooks/navigationHooks";
import { getRouting } from "../../../../helpers/Converters";
import { eventBaseRoute } from "../../../../routes/event";

//Name the component
const PackageAccessForm = (props) => {
  const accessListCredentials = useSelector(selectAccessListCredentials);
  const tournament = useSelector(selectPublicTournament);
  const dispatch = useDispatch();

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: true,
    data: accessListCredentials,
    setData: (update) => {
      dispatch(setAccessListCredentials(update));
      dispatch(applyAccessCodes(update));
    },
  });

  const navigate = useGolfstatusNavigate(getRouting(eventBaseRoute, [tournament?.publicUrl, "packages"] ));

  const notifications = useNotifications().filteredNotifications(["getTournamentAccessCode"])

  useNotificationAction(
    FULFILLED,
    notifications,
    () => {
      leftNavigation()    
    },
    "getTournamentAccessCode"
  );

  const save = () => {
    const filter = { ...accessListCredentials, tournamentID: tournament?.id };
    dispatch(getTournamentAccessCode(filter));
    setIsValid(false);
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Apply Credentials",
        isDisabled: !isValid,
        action: save,
        type: "black",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const leftNavigation = () => {
    dispatch(clearNotifications())
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Access List Credentials`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle="Access List Credentials"
        formSections={getAccessListForm(context)}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <package-access-form>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </package-access-form>
  );
};

//export the new namet
export default PackageAccessForm;
